module.exports = __webpack_public_path__ + "static/media/energy-consumption-icon.765178d2.png";